export default {"src":"/_next/static/media/smartphone_64.7e7ae2b8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};